import request from '@/utils/request'
import store from '@/store'

export function getUserProjectApi (data = {}) {
  return request({
    method: 'get',
    url: 'point/getUserProject',
    data: data,
    isToken: true
  })
}

export function getPointApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'get',
    url: 'point/getPointData?project_id=' + data.project_id,
    data: data,
    isToken: true
  })
}

export function getCityTableApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'get',
    url: 'point/getCityTable?project_id=' + data.project_id,
    data: data,
    isToken: true
  })
}

export function subCityApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subCity',
    data: data,
    isToken: true
  })
}

export function subAudiencesApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subAudiences',
    data: data,
    isToken: true
  })
}

export function getCityPriceApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getCityPrice',
    data: data,
    isToken: true
  })
}

export function subFeatureApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subFeature',
    data: data,
    isToken: true
  })
}

export function subMediaTypeApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subMediaType',
    data: data,
    isToken: true
  })
}

export function getPointResultApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getPointResult',
    data: data,
    isToken: true
  })
}

export function subInterfereApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subInterfere',
    data: data,
    isToken: true
  })
}

export function subCompanyApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subCompany',
    data: data,
    isToken: true
  })
}

export function subInstallPositionApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subInstallPosition',
    data: data,
    isToken: true
  })
}

export function subSameBuildingWayApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subSameBuildingWay',
    data: data,
    isToken: true
  })
}

export function subExposureApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subExposure',
    data: data,
    isToken: true
  })
}

export function getMediaPlayZhpApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getMediaPlayZhp',
    data: data,
    isToken: true
  })
}

export function subSameLatApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subSameLat',
    data: data,
    isToken: true
  })
}

export function getSameLatTableApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getSameLatTable',
    data: data,
    isToken: true
  })
}

export function buildSameLatFormApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/buildSameLatForm',
    data: data,
    isToken: true
  })
}

export function subSceneOptimizeApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subSceneOptimize',
    data: data,
    isToken: true
  })
}

export function subCoverWayApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subCoverWay',
    data: data,
    isToken: true
  })
}

export function subEfficiencyFirstApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subEfficiencyFirst',
    data: data,
    isToken: true
  })
}

export function subCustomApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subCustom',
    data: data,
    isToken: true
  })
}

export function saveAlwaysApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/saveAlways',
    data: data,
    isToken: true
  })
}

export function createProjectApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/createPointProject',
    data: data,
    isToken: true
  })
}

export function getProjectApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getPointProject',
    data: data,
    isToken: true
  })
}

export function delProjectApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/delPointProject',
    data: data,
    isToken: true
  })
}

export function getPointProjectReportApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getPointProjectReport',
    data: data,
    isToken: true
  })
}

export function createExportApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/createExport',
    data: data,
    isToken: true
  })
}

export function communityCheckApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/communityCheck',
    data: data,
    isToken: true
  })
}

export function getUserCitiesApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getUserCities',
    data: data,
    isToken: true
  })
}

// 地图选点提交
export function subMapPoint (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subMapPoint',
    data: data,
    isToken: true
  })
}

// 地图选点 - 导入坐标
export function subImportLat (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/subImportLat',
    data: data,
    isToken: true
  })
}

// 地图选点 - 获取坐标
export function getUserCoordinate (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/getUserCoordinate',
    data: data,
    isToken: true
  })
}

// 保存楼盘抽查
export function saveCommunityCheckApi (data = {}) {
  data.project_id = store.state.project.id
  return request({
    method: 'post',
    url: 'point/saveCommunityCheck',
    data: data,
    isToken: true
  })
}

// 获取用户报告选项数据
export function getUserReportApi (data = {}) {
  return request({
    method: 'post',
    url: 'point/getUserReport',
    data: data,
    isToken: true
  })
}

// 保存用户报告选项数据
export function saveUserReportApi (data = {}) {
  return request({
    method: 'post',
    url: 'point/saveUserReport',
    data: data,
    isToken: true
  })
}

// 获取用户报告对应项目
export function getReportProjectListApi (data = {}) {
  return request({
    method: 'post',
    url: 'point/getReportProjectList',
    data: data,
    isToken: true
  })
}

// 获取用户报告数据
export function getReportDataApi (data = {}) {
  return request({
    method: 'post',
    url: 'point/getReportData',
    data: data,
    isToken: true
  })
}

// 获取用户报告数据
export function getUserCityApi (data = {}) {
  return request({
    method: 'post',
    url: 'user/getUserCity',
    data: data,
    isToken: true
  })
}
